import { Box } from '@mantine/core'
import React from 'react'
import Footer from '../components/ui/Footer/Footer'
import Navbar from '../components/ui/Navbar/Navbar'

const Layout = ({ children }) => {
  return (
    <Box>
      <Navbar />
      <Box py={40}>
        {children}
      </Box>
      <Footer />
    </Box>
  )
}

export default Layout